
import { partition, fold, sumBy, indexed, find, tryFind, allPairs, tryHead, choose, cons, append, contains, sortBy, minBy, ofArray, max as max_1, min as min_1, singleton, maxBy, sortWith, head, updateAt, collect, isEmpty, truncate, zip, pairwise, initialize, filter, map, ofArrayWithTail, getSlice, empty, item, length as length_1, mapIndexed } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { DrawModelType_BusWireT_segments_, DrawModelType_BusWireT_wireOf_, DrawModelType_SymbolT_DirectedPortId, DrawModelType_SymbolT_Annotation, DrawModelType_BusWireT_Wire, DrawModelType_BusWireT_Segment } from "../Model/DrawModelType.js";
import { compare, compareArrays, numberHash, Exception, comparePrimitives, safeHash, equals, sign } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { max, min } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { makeInitialSegmentsList, Constants_nubLength } from "./BusWire.js";
import { isManuallyRouted, filterWiresByCompMoved, partialAutoroute, autoroute, portInset, makeEndsDraggable, rotateSegments, extendNubsToPorts, outwardOf, PortInfo, rotateStartDest, reverseWire } from "./BusWireUpdateHelpers.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { Edge, Rotation, BoundingBox, XYPos } from "../Common/CommonTypes.js";
import { MapModule_ValuesL } from "../Common/EEExtensions.js";
import { moveWire, getAbsSegments, isWireInNet, getWireLength, getStartAndEndWirePos, Constants_intervalTolerance, segmentIntersectsBoundingBox, segmentsToIssieVertices } from "./BlockHelpers.js";
import { FSharpMap__get_Item } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Constants_maxCallsToShiftHorizontalSeg, Constants_overlapTolerance, swapXYWhenVertical, Constants_smallOffset, Constants_wireSeparationFromSymbol, swapBBXAndY, updatePos, Constants_minWireSeparation } from "./BusWireRoutingHelpers.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { union_type, float64_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { toList } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { dbg } from "../Shared/Log.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { getPortLocation } from "./Symbol.js";
import { FSharpSet__Contains, ofList } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";

/**
 * add a nub and zero length segment to the start of the wire if needed
 * 
 * `inset` is how far this end's port sits INSIDE its own symbol's bounding box - not zero for a
 * mux SEL, see BusWireUpdateHelpers.portInset. This shortens a nub to fit the run the wire has,
 * and it does that in the space autoroute routes in: the first `inset` of the nub is inside the
 * symbol and is not room the wire may spend, so it is taken off before the length is worked out
 * and put back afterwards. The `max 0.` is what stops the wire's own end being drawn back past
 * the box edge - a nub of exactly the inset, whose turn then sits ON the edge with every pass
 * downstream free to read it as either side.
 */
export function ensureStartingNub(inset, wire) {
    const updateIndices = (list) => mapIndexed((i, seg) => (new DrawModelType_BusWireT_Segment(i, seg.Length, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode)), list);
    const segs = wire.Segments;
    if (length_1(segs) <= 2) {
        return wire;
    }
    else if ((item(1, segs).Length === 0) && ((sign(item(0, segs).Length) * sign(item(2, segs).Length)) === -1)) {
        const totalLength = item(0, segs).Length + item(2, segs).Length;
        const dir = sign(item(0, segs).Length);
        const thisNubLength = inset + min(Constants_nubLength, max(0, Math.abs(totalLength) - inset));
        let nub;
        const bind$0040 = item(0, segs);
        nub = (new DrawModelType_BusWireT_Segment(bind$0040.Index, dir * thisNubLength, bind$0040.WireId, empty(), false, bind$0040.Mode));
        let newSeg2;
        const bind$0040_1 = item(0, segs);
        newSeg2 = (new DrawModelType_BusWireT_Segment(bind$0040_1.Index, totalLength - (dir * thisNubLength), bind$0040_1.WireId, empty(), true, bind$0040_1.Mode));
        return new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, updateIndices(ofArrayWithTail([nub, item(1, segs), newSeg2], getSlice(3, undefined, segs))), wire.StartPos, wire.InitialOrientation);
    }
    else if (item(1, segs).Length !== 0) {
        const seg0 = item(0, segs);
        const seg1 = item(1, segs);
        const dir_1 = sign(item(0, segs).Length);
        const thisNubLength_1 = inset + min(Constants_nubLength, max(0, Math.abs(seg0.Length) - inset));
        return new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, updateIndices(ofArrayWithTail([new DrawModelType_BusWireT_Segment(seg0.Index, dir_1 * thisNubLength_1, seg0.WireId, empty(), false, seg0.Mode), new DrawModelType_BusWireT_Segment(seg1.Index, 0, seg1.WireId, empty(), true, seg1.Mode), new DrawModelType_BusWireT_Segment(seg0.Index, seg0.Length - (dir_1 * thisNubLength_1), seg0.WireId, empty(), true, seg0.Mode)], getSlice(1, undefined, segs))), wire.StartPos, wire.InitialOrientation);
    }
    else {
        return wire;
    }
}

/**
 * `startInset` and `endInset` are the two ends' port insets, in the wire's own direction.
 */
export function ensureBothNubs(startInset, endInset) {
    return (arg_2) => reverseWire(ensureStartingNub(endInset, reverseWire(ensureStartingNub(startInset, arg_2))));
}

/**
 * Checks if a wire intersects any symbol within +/- minWireSeparation.
 * Returns, for each segment which intersects something, its index and the boxes it intersects.
 * 
 * Which segment is in the way is what decides which segment is worth moving, so it is kept rather
 * than flattened away: the shift code below used to choose a segment by the wire's segment count,
 * which is a guess where this is the answer.
 */
export function findWireSymbolIntersectionsBySegment(model, wire) {
    const allBoundingBoxes = map((s_1) => {
        let sym, patternInput, sym_1, comp, matchValue, vS, hS, matchValue_2, left, right;
        return [s_1.Component, (sym = s_1, (patternInput = ((sym_1 = sym, (comp = sym_1.Component, (matchValue = defaultArg(sym_1.HScale, 1), (vS = defaultArg(sym_1.VScale, 1), (hS = matchValue, (matchValue_2 = sym_1.STransform.Rotation, (matchValue_2.tag === 2) ? [comp.H * vS, comp.W * hS] : ((matchValue_2.tag === 1) ? [comp.W * hS, comp.H * vS] : ((matchValue_2.tag === 3) ? [comp.W * hS, comp.H * vS] : [comp.H * vS, comp.W * hS]))))))))), equals(sym.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton) ? (new BoundingBox((left = sym.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17)) : (new BoundingBox(sym.Pos, patternInput[1], patternInput[0]))))];
    }, filter((s) => equals(s.Annotation, undefined), MapModule_ValuesL(model.Symbol.Symbols)));
    const wireVertices = mapIndexed((i, tupledArg) => [i, new XYPos(tupledArg[0], tupledArg[1])], segmentsToIssieVertices(wire.Segments, wire));
    const indexes = initialize(length_1(wireVertices) - 2, (i_1) => ((i_1 + 1) | 0));
    const lastIndex = item(length_1(indexes) - 1, indexes) | 0;
    let segVertices;
    const segments = pairwise(getSlice(1, length_1(wireVertices) - 2, wireVertices));
    segVertices = zip(truncate(length_1(segments), indexes), segments);
    const inputCompId = FSharpMap__get_Item(model.Symbol.Ports, wire.InputPort).HostId;
    const outputCompId = FSharpMap__get_Item(model.Symbol.Ports, wire.OutputPort).HostId;
    return filter((tupledArg_6) => !isEmpty(tupledArg_6[1]), map((tupledArg_5) => {
        let tupledArg_1, tupledArg_2;
        const _arg_4 = tupledArg_5[1];
        return [tupledArg_5[0], (tupledArg_1 = _arg_4[0], (tupledArg_2 = _arg_4[1], map((tuple) => tuple[1], filter((tupledArg_4) => {
            const matchValue_3 = segmentIntersectsBoundingBox(tupledArg_4[1], tupledArg_1[1], tupledArg_2[1]);
            if (matchValue_3 == null) {
                return false;
            }
            else {
                return true;
            }
        }, map((tupledArg_3) => {
            let box, borderSize, W, H_2;
            const comp_1 = tupledArg_3[0];
            return [comp_1, (box = tupledArg_3[1], (borderSize = (((equals(comp_1.Id, outputCompId) && (tupledArg_1[0] <= 2)) ? true : (equals(comp_1.Id, inputCompId) && (tupledArg_2[0] >= (lastIndex - 2)))) ? 0 : Constants_minWireSeparation), (W = (box.W + (borderSize * 2)), (H_2 = (box.H + (borderSize * 2)), new BoundingBox(updatePos("up_", borderSize, updatePos("left_", borderSize, box.TopLeft)), W, H_2)))))];
        }, allBoundingBoxes)))))];
    }, segVertices));
}

/**
 * Bounding boxes of symbols intersected by wire, however many of its segments hit them.
 */
export function findWireSymbolIntersections(model, wire) {
    return List_distinct(collect((tuple) => tuple[1], findWireSymbolIntersectionsBySegment(model, wire)), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

/**
 * update the length of a segment in a list of segments
 */
export function changeSegment(segIndex, newLength, segments) {
    let bind$0040;
    return updateAt(segIndex, (bind$0040 = item(segIndex, segments), new DrawModelType_BusWireT_Segment(bind$0040.Index, newLength, bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode)), segments);
}

/**
 * Try shifting vertical seg (index 3) to either - wireSeparationFromSymbol or + wireSeparationFromSymbol from
 * the edge of all the intersectedBoundingBoxes symbols.
 * Returns None if no route found.
 */
export function tryShiftVerticalSeg(model, intersectedBoxes, wire) {
    const origWireVertices = map((tupledArg) => (new XYPos(tupledArg[0], tupledArg[1])), segmentsToIssieVertices(wire.Segments, wire));
    const tryshiftedWireWithoutIntersections = (dir_1) => {
        let matchValue, source_1, bind$0040, bind$0040_1;
        let shifted;
        const dir = dir_1;
        const boxToGoRound = head(sortWith((box1, box2) => {
            const box1_1 = swapBBXAndY(box1, wire.InitialOrientation);
            const box2_1 = swapBBXAndY(box2, wire.InitialOrientation);
            switch (dir) {
                case "left_":
                    return comparePrimitives(box1_1.TopLeft.X, box2_1.TopLeft.X) | 0;
                case "right_":
                    return comparePrimitives(box2_1.TopLeft.X + box2_1.W, box1_1.TopLeft.X + box1_1.W) | 0;
                default:
                    throw new Exception("Invalid direction to shift wire");
            }
        }, intersectedBoxes));
        const clearBy = (Constants_wireSeparationFromSymbol - Constants_minWireSeparation) + Constants_smallOffset;
        const amountToShift = swapXYWhenVertical((matchValue = wire.InitialOrientation, (dir === "left_") ? ((matchValue === "vertical") ? updatePos("up_", clearBy, boxToGoRound.TopLeft) : updatePos("left_", clearBy, boxToGoRound.TopLeft)) : ((dir === "right_") ? ((matchValue === "vertical") ? updatePos("down_", boxToGoRound.H + clearBy, boxToGoRound.TopLeft) : updatePos("right_", boxToGoRound.W + clearBy, boxToGoRound.TopLeft)) : (() => {
            throw new Exception("Invalid direction to shift wire");
        })())), wire.InitialOrientation).X - swapXYWhenVertical(item(4, origWireVertices), wire.InitialOrientation).X;
        shifted = (new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, (source_1 = updateAt(2, (bind$0040 = item(2, wire.Segments), new DrawModelType_BusWireT_Segment(bind$0040.Index, item(2, wire.Segments).Length + amountToShift, bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode)), wire.Segments), updateAt(4, (bind$0040_1 = item(4, wire.Segments), new DrawModelType_BusWireT_Segment(bind$0040_1.Index, item(4, wire.Segments).Length - amountToShift, bind$0040_1.WireId, bind$0040_1.IntersectOrJumpList, bind$0040_1.Draggable, bind$0040_1.Mode)), source_1)), wire.StartPos, wire.InitialOrientation));
        if (isEmpty(findWireSymbolIntersections(model, shifted))) {
            return shifted;
        }
        else {
            return undefined;
        }
    };
    const option_1 = tryshiftedWireWithoutIntersections("left_");
    if (option_1 != null) {
        return option_1;
    }
    else {
        return tryshiftedWireWithoutIntersections("right_");
    }
}

export class VertDistFromBoundingBox extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Above", "Below"];
    }
}

export function VertDistFromBoundingBox_$reflection() {
    return union_type("BusWireRoute.VertDistFromBoundingBox", [], VertDistFromBoundingBox, () => [[["Item", float64_type]], [["Item", float64_type]]]);
}

export function tryMaxDistance(distances) {
    if (isEmpty(distances)) {
        return undefined;
    }
    else {
        return maxBy((_arg) => {
            let matchResult, d;
            if (_arg == null) {
                matchResult = 1;
            }
            else if (_arg.tag === 1) {
                matchResult = 0;
                d = _arg.fields[0];
            }
            else {
                matchResult = 0;
                d = _arg.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return d;
                default:
                    return -Number.POSITIVE_INFINITY;
            }
        }, distances, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
    }
}

/**
 * returns the maximum vertical distance of pos from intersectedBoxes as a VertDistFromBoundingBox or None if there are no intersections
 */
export function maxVertDistanceFromBox(intersectedBoxes, wireOrientation, pos) {
    return tryMaxDistance(collect((box_3) => {
        let box, x, b;
        const pos_3 = swapXYWhenVertical(pos, wireOrientation);
        const box_2 = swapBBXAndY(box_3, wireOrientation);
        if ((box = box_2, (x = pos_3.X, (b = (box.TopLeft.X + box.W), ((box.TopLeft.X - Constants_intervalTolerance) < x) && (x < (b + Constants_intervalTolerance)))))) {
            if (pos_3.Y > box_2.TopLeft.Y) {
                return singleton(new VertDistFromBoundingBox(/* Above */ 0, [pos_3.Y - box_2.TopLeft.Y]));
            }
            else {
                return singleton(new VertDistFromBoundingBox(/* Below */ 1, [(box_2.TopLeft.Y - pos_3.Y) + box_2.H]));
            }
        }
        else {
            return empty();
        }
    }, intersectedBoxes));
}

/**
 * Recursively shift horizontal seg up/down until no symbol intersections.
 * Limit in recursion depth defined by argument callsLeft given to initial function call.
 * Limit needed to prevent Issie from breaking when there are physically
 * no possible routes that achieve 0 intersections.
 * Returns None if no route found
 */
export function tryShiftHorizontalSeg(callsLeft, model, intersectedBoxes, wire) {
    if (callsLeft === 0) {
        return undefined;
    }
    else {
        let tryShiftHorizontalSeg_1;
        const callsLeft_1 = (callsLeft - 1) | 0;
        tryShiftHorizontalSeg_1 = ((model_1) => ((intersectedBoxes_1) => ((wire_1) => tryShiftHorizontalSeg(callsLeft_1, model_1, intersectedBoxes_1, wire_1))));
        const patternInput = getStartAndEndWirePos(wire);
        const currentStartPos = patternInput[0];
        const currentEndPos = patternInput[1];
        const orientation = wire.InitialOrientation;
        const getXOrY = (pos) => {
            if (orientation === "vertical") {
                return pos.Y;
            }
            else {
                return pos.X;
            }
        };
        const getOppositeXOrY = (pos_1) => {
            if (orientation === "vertical") {
                return pos_1.X;
            }
            else {
                return pos_1.Y;
            }
        };
        const getOppositeWOrH = (box_1) => {
            if (orientation === "vertical") {
                return box_1.W;
            }
            else {
                return box_1.H;
            }
        };
        const blockedSegments = map((tuple) => (tuple[0] | 0), findWireSymbolIntersectionsBySegment(model, wire));
        let turnPositions;
        const nearSide = min_1(map((b) => getXOrY(b.TopLeft), intersectedBoxes), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        const farSide = max_1(map((b_1) => {
            let box;
            return getXOrY(b_1.TopLeft) + ((box = b_1, (orientation === "vertical") ? box.H : box.W));
        }, intersectedBoxes), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        });
        turnPositions = ofArray([getXOrY(currentEndPos), (nearSide - Constants_minWireSeparation) - Constants_smallOffset, (farSide + Constants_minWireSeparation) + Constants_smallOffset]);
        const goodWire = (dir) => {
            let clo, moveHorizSegment, matchValue, source, segments_2, bind$0040;
            let candidates;
            const direction = dir;
            const patternInput_3 = (direction === "up_") ? [(_arg) => 0, "left_"] : ((direction === "down_") ? [getOppositeWOrH, "right_"] : toFail(printf("What? Can\'t happen")));
            const boundBox = ((direction === "down_") ? ((list_8) => maxBy((box_3) => (getOppositeXOrY(box_3.TopLeft) + getOppositeWOrH(box_3)), list_8, {
                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
            })) : ((direction === "up_") ? ((list_9) => minBy((box_4) => getOppositeXOrY(box_4.TopLeft), list_9, {
                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
            })) : ((clo = toFail(printf("What? Can\'t happen")), clo))))(intersectedBoxes);
            let bound_1;
            const offset = ((Constants_wireSeparationFromSymbol - Constants_minWireSeparation) + Constants_smallOffset) + patternInput_3[0](boundBox);
            bound_1 = getOppositeXOrY(updatePos((orientation === "vertical") ? patternInput_3[1] : direction, offset, boundBox.TopLeft));
            const matchValue_5 = bound_1 - getOppositeXOrY(currentStartPos);
            const secondVerticalSegLength_2 = getOppositeXOrY(currentEndPos) - bound_1;
            const firstVerticalSegLength_2 = matchValue_5;
            const movableHorizontals = sortBy((i_12) => {
                if (contains(i_12, blockedSegments, {
                    Equals: (x_4, y_4) => (x_4 === y_4),
                    GetHashCode: (x_4) => (numberHash(x_4) | 0),
                })) {
                    return 0;
                }
                else {
                    return 1;
                }
            }, toList(rangeDouble(2, 2, length_1(wire.Segments) - 3)), {
                Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
            });
            candidates = append(cons((moveHorizSegment = ((vertSegIndex) => {
                let f1;
                const segIndex = (vertSegIndex - 1) | 0;
                f1 = ((segments) => changeSegment(segIndex, firstVerticalSegLength_2, segments));
                let f2;
                const segIndex_1 = (vertSegIndex + 1) | 0;
                f2 = ((segments_1) => changeSegment(segIndex_1, secondVerticalSegLength_2, segments_1));
                return (arg) => f2(f1(arg));
            }), new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, (matchValue = (length_1(wire.Segments) | 0), (matchValue === 5) ? moveHorizSegment(2)(wire.Segments) : ((matchValue === 6) ? moveHorizSegment(2)(wire.Segments) : ((matchValue === 7) ? ((source = ((segments_2 = moveHorizSegment(2)(getSlice(undefined, 4, wire.Segments)), changeSegment(2, item(2, wire.Segments).Length + item(4, wire.Segments).Length, segments_2))), updateAt(4, (bind$0040 = item(6, wire.Segments), new DrawModelType_BusWireT_Segment(4, bind$0040.Length, bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode)), source))) : ((matchValue === 8) ? moveHorizSegment(4)(changeSegment(1, 0, wire.Segments)) : ((matchValue === 9) ? changeSegment(7, 0, moveHorizSegment(4)(changeSegment(1, 0, wire.Segments))) : ((dbg(4, `cannot shift the horizontal segment of a ${matchValue} segment wire`), wire.Segments))))))), wire.StartPos, wire.InitialOrientation)), map((i_13) => {
                const segIndex_6 = i_13 | 0;
                const lastIndex = (length_1(wire.Segments) - 1) | 0;
                return new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, mapIndexed((i, seg) => {
                    if (i === (segIndex_6 - 1)) {
                        return new DrawModelType_BusWireT_Segment(seg.Index, firstVerticalSegLength_2, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode);
                    }
                    else if (i === (segIndex_6 + 1)) {
                        return new DrawModelType_BusWireT_Segment(seg.Index, secondVerticalSegLength_2, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode);
                    }
                    else if (((i % 2) === 1) && (i !== lastIndex)) {
                        return new DrawModelType_BusWireT_Segment(seg.Index, 0, seg.WireId, seg.IntersectOrJumpList, seg.Draggable, seg.Mode);
                    }
                    else {
                        return seg;
                    }
                }, wire.Segments), wire.StartPos, wire.InitialOrientation);
            }, movableHorizontals)), choose((tupledArg) => {
                let remainder;
                const segIndex_7 = tupledArg[0] | 0;
                const bound = bound_1;
                const turn = tupledArg[1];
                const segs = wire.Segments;
                const last = (length_1(segs) - 1) | 0;
                const matchValue_1 = getXOrY(currentStartPos);
                const matchValue_2 = getXOrY(currentEndPos);
                const matchValue_3 = getOppositeXOrY(currentStartPos);
                const matchValue_4 = getOppositeXOrY(currentEndPos);
                const option_1 = tryHead(toList(rangeDouble(segIndex_7 + 2, 2, last - 1)));
                if (option_1 != null) {
                    return (remainder = (option_1 | 0), new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, mapIndexed((i_1, seg_1) => (new DrawModelType_BusWireT_Segment(seg_1.Index, (i_1 === 0) ? seg_1.Length : ((i_1 === last) ? seg_1.Length : ((i_1 === (segIndex_7 - 1)) ? (bound - matchValue_3) : ((i_1 === (segIndex_7 + 1)) ? (matchValue_4 - bound) : ((i_1 === segIndex_7) ? ((turn - matchValue_1) - item(0, segs).Length) : ((i_1 === remainder) ? (matchValue_2 - turn) : 0))))), seg_1.WireId, seg_1.IntersectOrJumpList, seg_1.Draggable, seg_1.Mode)), segs), wire.StartPos, wire.InitialOrientation));
                }
                else {
                    return undefined;
                }
            }, allPairs(movableHorizontals, turnPositions)));
            const matchValue_7 = tryFind((w) => isEmpty(findWireSymbolIntersections(model, w)), candidates);
            if (matchValue_7 == null) {
                const firstTry = head(candidates);
                return new FSharpResult$2(/* Error */ 1, [[findWireSymbolIntersections(model, firstTry), firstTry]]);
            }
            else {
                return new FSharpResult$2(/* Ok */ 0, [matchValue_7]);
            }
        };
        const matchValue_8 = goodWire("up_");
        const matchValue_9 = goodWire("down_");
        const copyOfStruct = matchValue_8;
        if (copyOfStruct.tag === 1) {
            const copyOfStruct_1 = matchValue_9;
            if (copyOfStruct_1.tag === 1) {
                const _arg_1 = tryMaxDistance(map((pos_2) => maxVertDistanceFromBox(intersectedBoxes, wire.InitialOrientation, pos_2), ofArray([currentStartPos, currentEndPos])));
                let matchResult;
                if (_arg_1 != null) {
                    if (_arg_1.tag === 1) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 0;
                    }
                }
                else {
                    matchResult = 0;
                }
                switch (matchResult) {
                    case 0:
                        return tryShiftHorizontalSeg_1(model)(copyOfStruct_1.fields[0][0])(copyOfStruct_1.fields[0][1]);
                    default:
                        return tryShiftHorizontalSeg_1(model)(copyOfStruct.fields[0][0])(copyOfStruct.fields[0][1]);
                }
            }
            else {
                return copyOfStruct_1.fields[0];
            }
        }
        else {
            const copyOfStruct_2 = matchValue_9;
            if (copyOfStruct_2.tag === 0) {
                if (getWireLength(copyOfStruct.fields[0]) < getWireLength(copyOfStruct_2.fields[0])) {
                    return copyOfStruct.fields[0];
                }
                else {
                    return copyOfStruct_2.fields[0];
                }
            }
            else {
                return copyOfStruct.fields[0];
            }
        }
    }
}

export function getWireVertices(wire) {
    return map((tupledArg) => (new XYPos(tupledArg[0], tupledArg[1])), segmentsToIssieVertices(wire.Segments, wire));
}

export function copySegments(wire, refWire, numOfSegsToCopy) {
    return map((i) => {
        const bind$0040 = item(i, wire.Segments);
        return new DrawModelType_BusWireT_Segment(bind$0040.Index, item(i, refWire.Segments).Length, bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode);
    }, toList(rangeDouble(0, 1, numOfSegsToCopy - 1)));
}

export function generateEndSegments(startIndex, numOfSegs, wire) {
    let bind$0040_1;
    const source = map((i) => {
        const bind$0040 = item(i % 2, wire.Segments);
        return new DrawModelType_BusWireT_Segment(i, 0, bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode);
    }, toList(rangeDouble(startIndex, 1, (startIndex + numOfSegs) - 1)));
    return updateAt(numOfSegs - 1, (bind$0040_1 = item(numOfSegs - 1, wire.Segments), new DrawModelType_BusWireT_Segment(bind$0040_1.Index, Constants_nubLength, bind$0040_1.WireId, bind$0040_1.IntersectOrJumpList, bind$0040_1.Draggable, bind$0040_1.Mode)), source);
}

/**
 * Finds the first reference wire in a net and keeps the same segment lengths
 * as much as possible based on a heuristic.
 * Snap to net only implemented for one orientation
 */
export function snapToNet(model, wireToRoute) {
    let n, bind$0040_4, bind$0040_5, bind$0040_6, bind$0040_2, bind$0040_3, bind$0040, bind$0040_1;
    const inputCompId = FSharpMap__get_Item(model.Symbol.Ports, wireToRoute.InputPort).HostId;
    const outputCompId = FSharpMap__get_Item(model.Symbol.Ports, wireToRoute.OutputPort).HostId;
    const isRotated = ((equals(FSharpMap__get_Item(model.Symbol.Symbols, inputCompId).STransform.Rotation, Rotation.Degree90) ? true : equals(FSharpMap__get_Item(model.Symbol.Symbols, inputCompId).STransform.Rotation, Rotation.Degree270)) ? true : equals(FSharpMap__get_Item(model.Symbol.Symbols, outputCompId).STransform.Rotation, Rotation.Degree90)) ? true : equals(FSharpMap__get_Item(model.Symbol.Symbols, outputCompId).STransform.Rotation, Rotation.Degree270);
    const patternInput = getStartAndEndWirePos(wireToRoute);
    const wireToRouteStartPos = patternInput[0];
    const wireToRouteEndPos = patternInput[1];
    const matchValue = length_1(wireToRoute.Segments) | 0;
    const matchValue_2 = wireToRouteStartPos.X > wireToRouteEndPos.X;
    const matchValue_3 = isWireInNet(model, wireToRoute);
    if ((n = (matchValue | 0), (n !== 5) && (n !== 7))) {
        return wireToRoute;
    }
    else if (isRotated) {
        return wireToRoute;
    }
    else if (wireToRoute.InitialOrientation !== "horizontal") {
        return wireToRoute;
    }
    else if (matchValue_2) {
        return wireToRoute;
    }
    else if (matchValue_3 != null) {
        const refWire = find((tupledArg) => !equals(tupledArg[1].WId, wireToRoute.WId), matchValue_3[1])[1];
        const refWireVertices = getWireVertices(refWire);
        const patternInput_1 = getStartAndEndWirePos(refWire);
        const firstBendPos = item(3, refWireVertices);
        const isHorizontalSegTooShort = (wireToRouteEndPos.X - wireToRouteStartPos.X) < (item(2, refWire.Segments).Length / 2);
        let numOfSegsToCopy;
        let simpleCase;
        const matchValue_5 = wireToRouteEndPos.X < firstBendPos.X;
        simpleCase = (matchValue_5 ? (isHorizontalSegTooShort ? 1 : 2) : 3);
        const matchValue_7 = length_1(refWire.Segments) | 0;
        switch (matchValue_7) {
            case 5: {
                const matchValue_8 = firstBendPos.Y < patternInput_1[1].Y;
                const matchValue_9 = firstBendPos.Y > wireToRouteEndPos.Y;
                let matchResult;
                if (matchValue_8) {
                    if (matchValue_9) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else if (matchValue_9) {
                    matchResult = 1;
                }
                else {
                    matchResult = 0;
                }
                switch (matchResult) {
                    case 0: {
                        numOfSegsToCopy = ((wireToRouteEndPos.X < firstBendPos.X) ? 2 : 3);
                        break;
                    }
                    default:
                        numOfSegsToCopy = simpleCase;
                }
                break;
            }
            case 7: {
                numOfSegsToCopy = simpleCase;
                break;
            }
            default:
                numOfSegsToCopy = 0;
        }
        return new DrawModelType_BusWireT_Wire(wireToRoute.WId, wireToRoute.InputPort, wireToRoute.OutputPort, wireToRoute.Color, wireToRoute.Width, (numOfSegsToCopy === 0) ? wireToRoute.Segments : ((numOfSegsToCopy === 1) ? append(copySegments(wireToRoute, refWire, 1), append(singleton((bind$0040_4 = item(1, wireToRoute.Segments), new DrawModelType_BusWireT_Segment(bind$0040_4.Index, wireToRouteEndPos.Y - wireToRouteStartPos.Y, bind$0040_4.WireId, bind$0040_4.IntersectOrJumpList, bind$0040_4.Draggable, bind$0040_4.Mode))), append(singleton((bind$0040_5 = item(2, wireToRoute.Segments), new DrawModelType_BusWireT_Segment(bind$0040_5.Index, (wireToRouteEndPos.X - wireToRouteStartPos.X) - Constants_nubLength, bind$0040_5.WireId, bind$0040_5.IntersectOrJumpList, bind$0040_5.Draggable, bind$0040_5.Mode))), append(singleton((bind$0040_6 = item(3, wireToRoute.Segments), new DrawModelType_BusWireT_Segment(bind$0040_6.Index, 0, bind$0040_6.WireId, bind$0040_6.IntersectOrJumpList, bind$0040_6.Draggable, bind$0040_6.Mode))), generateEndSegments(4, 3, wireToRoute))))) : ((numOfSegsToCopy === 2) ? append(copySegments(wireToRoute, refWire, 2), append(singleton((bind$0040_2 = item(2, wireToRoute.Segments), new DrawModelType_BusWireT_Segment(bind$0040_2.Index, (wireToRouteEndPos.X - wireToRouteStartPos.X) - Constants_nubLength, bind$0040_2.WireId, bind$0040_2.IntersectOrJumpList, bind$0040_2.Draggable, bind$0040_2.Mode))), append(singleton((bind$0040_3 = item(3, wireToRoute.Segments), new DrawModelType_BusWireT_Segment(bind$0040_3.Index, wireToRouteEndPos.Y - firstBendPos.Y, bind$0040_3.WireId, bind$0040_3.IntersectOrJumpList, bind$0040_3.Draggable, bind$0040_3.Mode))), generateEndSegments(4, 3, wireToRoute)))) : ((numOfSegsToCopy === 3) ? append(copySegments(wireToRoute, refWire, 3), append(singleton((bind$0040 = item(3, wireToRoute.Segments), new DrawModelType_BusWireT_Segment(bind$0040.Index, wireToRouteEndPos.Y - firstBendPos.Y, bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode))), append(singleton((bind$0040_1 = item(4, wireToRoute.Segments), new DrawModelType_BusWireT_Segment(bind$0040_1.Index, wireToRouteEndPos.X - firstBendPos.X, bind$0040_1.WireId, bind$0040_1.IntersectOrJumpList, bind$0040_1.Draggable, bind$0040_1.Mode))), generateEndSegments(5, 2, wireToRoute)))) : toFail(printf("Shouldn\'t happen"))))), wireToRoute.StartPos, wireToRoute.InitialOrientation);
    }
    else {
        return wireToRoute;
    }
}

function edgeOfTravel(seg) {
    let matchValue;
    const this$ = seg;
    let delta;
    const left = this$.Start;
    const right = this$.End;
    delta = (new XYPos(left.X - right.X, left.Y - right.Y));
    matchValue = ((Math.abs(delta.X) > Math.abs(delta.Y)) ? "horizontal" : "vertical");
    const matchValue_1 = seg.Segment.Length > 0;
    if (matchValue === "vertical") {
        if (matchValue_1) {
            return Edge.Bottom;
        }
        else {
            return Edge.Top;
        }
    }
    else if (matchValue_1) {
        return Edge.Right;
    }
    else {
        return Edge.Left;
    }
}

function routeBetween(wid, startPos, startEdge, destPos, destEdge, destInset) {
    let left, right, pos, scaleFactor;
    const patternInput = rotateStartDest(Edge.Right, new PortInfo(startEdge, startPos), new PortInfo(destEdge, (left = destPos, (right = ((pos = outwardOf(destEdge), (scaleFactor = destInset, new XYPos(pos.X * scaleFactor, pos.Y * scaleFactor)))), new XYPos(left.X + right.X, left.Y + right.Y)))));
    const normEnd = patternInput[1];
    return extendNubsToPorts(0, destInset, rotateSegments(startEdge, {
        edge: Edge.Right,
        segments: makeInitialSegmentsList(wid, patternInput[0].Position, normEnd.Position, normEnd.Edge),
    }).segments);
}

function branchFrom(wire, refWire, branchAt, branchPos, edge, destPos, destEdge, destInset) {
    let this$, bind$0040;
    const onwards = routeBetween(wire.WId, branchPos, edge, destPos, destEdge, destInset);
    const shared = getSlice(0, branchAt, refWire.Segments);
    const patternInput = ((length_1(onwards) > 2) && ((this$ = item(1, onwards), Math.abs(this$.Length) < 1E-07))) ? [(item(branchAt, shared).Length + item(0, onwards).Length) + item(2, onwards).Length, getSlice(3, undefined, onwards)] : [item(branchAt, shared).Length + item(0, onwards).Length, getSlice(1, undefined, onwards)];
    return new DrawModelType_BusWireT_Wire(wire.WId, wire.InputPort, wire.OutputPort, wire.Color, wire.Width, makeEndsDraggable(map((seg) => (new DrawModelType_BusWireT_Segment(seg.Index, seg.Length, wire.WId, seg.IntersectOrJumpList, seg.Draggable, "auto")), append(getSlice(undefined, branchAt - 1, shared), append(singleton((bind$0040 = item(branchAt, shared), new DrawModelType_BusWireT_Segment(bind$0040.Index, patternInput[0], bind$0040.WireId, bind$0040.IntersectOrJumpList, bind$0040.Draggable, bind$0040.Mode))), patternInput[1])))), refWire.StartPos, refWire.InitialOrientation);
}

/**
 * Every way of routing `wire` as a branch off a wire of its own net which is already routed, each
 * paired with how far its branch point is from the destination.
 * 
 * A branch takes over the reference wire's start position, so every wire it may follow has to be
 * one that is drawn from where the driver port is NOW. A wire with no segments is passed over,
 * which is what makes taking the routing off a set of wires before routing any of them enough to
 * guarantee it - see `rerouteMovedWires`. Follow a wire that has not been re-routed since its
 * driver moved and this wire is drawn from where that port used to be, joined to nothing.
 * 
 * That distance is the whole of the choice: take the first of these that is legal and the branch
 * point is the nearest one to the destination that works, which is the one the wire can follow
 * for longest. The ordinary route belongs in the same ordering - it is the branch at the driver
 * port, where nothing is shared - so a branch is taken only when it starts nearer the destination
 * than starting again from the port would.
 */
export function sameNetRoutes(model, wire) {
    let portId_1;
    const destPos = getPortLocation(undefined, model.Symbol, (portId_1 = (new DrawModelType_SymbolT_DirectedPortId(/* InputId */ 0, [wire.InputPort])), (portId_1.tag === 1) ? portId_1.fields[0] : portId_1.fields[0]));
    let destEdge;
    const model_4 = model.Symbol;
    let portId_9;
    const portId_6 = new DrawModelType_SymbolT_DirectedPortId(/* InputId */ 0, [wire.InputPort]);
    portId_9 = ((portId_6.tag === 1) ? portId_6.fields[0] : portId_6.fields[0]);
    destEdge = FSharpMap__get_Item(FSharpMap__get_Item(model_4.Symbols, FSharpMap__get_Item(model_4.Ports, portId_9).HostId).PortMaps.Orientation, portId_9);
    const destInset = portInset(model.Symbol, wire.InputPort);
    return map((tupledArg_2) => {
        let vec, left, right;
        const branchPos = tupledArg_2[2];
        return [(vec = ((left = branchPos, (right = destPos, new XYPos(left.X - right.X, left.Y - right.Y)))), Math.sqrt(Math.pow(vec.X, 2) + Math.pow(vec.Y, 2))), branchFrom(wire, tupledArg_2[0], tupledArg_2[1], branchPos, tupledArg_2[3], destPos, destEdge, destInset)];
    }, collect((refWire) => map((tupledArg_1) => {
        const seg_1 = tupledArg_1[1];
        return [refWire, tupledArg_1[0], seg_1.End, edgeOfTravel(seg_1)];
    }, filter((tupledArg) => {
        if (tupledArg[0] < (length_1(refWire.Segments) - 1)) {
            return !(Math.abs(tupledArg[1].Segment.Length) < 1E-07);
        }
        else {
            return false;
        }
    }, indexed(getAbsSegments(refWire)))), filter((w) => {
        if (equals(w.OutputPort, wire.OutputPort) && !equals(w.WId, wire.WId)) {
            return !isEmpty(w.Segments);
        }
        else {
            return false;
        }
    }, MapModule_ValuesL(model.Wires))));
}

/**
 * top-level function which replaces autoupdate and implements a smarter version of same
 * it is called every time a new wire is created, so is easily tested.
 */
export function smartAutoroute(model, wire) {
    let option_1, vec, left_1, right_1, portId_1, option_4;
    const initialWire = autoroute(model, wire);
    let snappedToNetWire;
    if (model.SnapToNet) {
        const spansOf = (w) => map((s_1) => {
            let matchValue_1;
            const this$_1 = s_1;
            let delta;
            const left = this$_1.Start;
            const right = this$_1.End;
            delta = (new XYPos(left.X - right.X, left.Y - right.Y));
            matchValue_1 = ((Math.abs(delta.X) > Math.abs(delta.Y)) ? "horizontal" : "vertical");
            if (matchValue_1 === "vertical") {
                return ["vertical", s_1.Start.X, min(s_1.Start.Y, s_1.End.Y), max(s_1.Start.Y, s_1.End.Y)];
            }
            else {
                return ["horizontal", s_1.Start.Y, min(s_1.Start.X, s_1.End.X), max(s_1.Start.X, s_1.End.X)];
            }
        }, filter((s) => !(Math.abs(s.Segment.Length) < 1E-07), getAbsSegments(w)));
        const alreadyDrawn = collect(spansOf, filter((w_1) => {
            if (equals(w_1.OutputPort, wire.OutputPort) && !equals(w_1.WId, wire.WId)) {
                return !isEmpty(w_1.Segments);
            }
            else {
                return false;
            }
        }, MapModule_ValuesL(model.Wires)));
        snappedToNetWire = defaultArg((option_1 = tryFind((tupledArg_5) => isEmpty(findWireSymbolIntersections(model, tupledArg_5[1])), sortBy((tupledArg_4) => {
            const w_3 = tupledArg_4[1];
            return [sumBy((tupledArg_2) => {
                let list_5;
                const lo_1 = tupledArg_2[2];
                const hi_1 = tupledArg_2[3];
                return (hi_1 - lo_1) - ((list_5 = sortBy((tuple) => tuple[0], choose((tupledArg_3) => {
                    const l = tupledArg_3[2];
                    const h = tupledArg_3[3];
                    if (((tupledArg_3[0] === tupledArg_2[0]) && (Math.abs(tupledArg_3[1] - tupledArg_2[1]) < Constants_overlapTolerance)) && (min(hi_1, h) > max(lo_1, l))) {
                        return [max(lo_1, l), min(hi_1, h)];
                    }
                    else {
                        return undefined;
                    }
                }, alreadyDrawn), {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                }), fold((tupledArg, tupledArg_1) => {
                    const upTo = tupledArg[1];
                    const hi = tupledArg_1[1];
                    return [tupledArg[0] + max(0, hi - max(tupledArg_1[0], upTo)), max(upTo, hi)];
                }, [0, -Number.POSITIVE_INFINITY], list_5)))[0];
            }, spansOf(w_3), {
                GetZero: () => 0,
                Add: (x_1, y_1) => (x_1 + y_1),
            }), sumBy((sg) => Math.abs(sg.Length), w_3.Segments, {
                GetZero: () => 0,
                Add: (x_2, y_2) => (x_2 + y_2),
            }), tupledArg_4[0]];
        }, cons([(vec = ((left_1 = initialWire.StartPos, (right_1 = getPortLocation(undefined, model.Symbol, (portId_1 = (new DrawModelType_SymbolT_DirectedPortId(/* InputId */ 0, [wire.InputPort])), (portId_1.tag === 1) ? portId_1.fields[0] : portId_1.fields[0])), new XYPos(left_1.X - right_1.X, left_1.Y - right_1.Y)))), Math.sqrt(Math.pow(vec.X, 2) + Math.pow(vec.Y, 2))), initialWire], sameNetRoutes(model, wire)), {
            Compare: (x_3, y_3) => (compareArrays(x_3, y_3) | 0),
        })), (option_1 != null) ? option_1[1] : undefined), initialWire);
    }
    else {
        snappedToNetWire = initialWire;
    }
    const intersectedBoxes = findWireSymbolIntersections(model, snappedToNetWire);
    if (length_1(intersectedBoxes) === 0) {
        return snappedToNetWire;
    }
    else {
        const nubbedWire = ensureBothNubs(portInset(model.Symbol, wire.OutputPort), portInset(model.Symbol, wire.InputPort))(snappedToNetWire);
        return defaultArg((option_4 = tryShiftVerticalSeg(model, intersectedBoxes, nubbedWire), (option_4 != null) ? option_4 : tryShiftHorizontalSeg(Constants_maxCallsToShiftHorizontalSeg, model, intersectedBoxes, snappedToNetWire)), nubbedWire);
    }
}

/**
 * Returns a single re-routed wire from the given model.
 * First attempts partial autorouting, and defaults to full autorouting if this is not possible.
 * Reverse indicates if the wire should be processed in reverse,
 * used when an input port (end of wire) is moved.
 */
export function updateWire(model, wire, reverse) {
    let portId_1, portId_5;
    const newPort = reverse ? getPortLocation(undefined, model.Symbol, (portId_1 = (new DrawModelType_SymbolT_DirectedPortId(/* InputId */ 0, [wire.InputPort])), (portId_1.tag === 1) ? portId_1.fields[0] : portId_1.fields[0])) : getPortLocation(undefined, model.Symbol, (portId_5 = (new DrawModelType_SymbolT_DirectedPortId(/* OutputId */ 1, [wire.OutputPort])), (portId_5.tag === 1) ? portId_5.fields[0] : portId_5.fields[0]));
    let option_3;
    if (reverse) {
        const option_1 = partialAutoroute(model, reverseWire(wire), newPort, true);
        option_3 = ((option_1 != null) ? reverseWire(option_1) : undefined);
    }
    else {
        option_3 = partialAutoroute(model, wire, newPort, false);
    }
    if (option_3 != null) {
        return option_3;
    }
    else {
        return smartAutoroute(model, wire);
    }
}

/**
 * Re-route the wires which touch a symbol that has moved. A wire with both ends on moved symbols
 * keeps its shape and is handed to `translate` - it moves with them.
 * 
 * The routing comes off the wires that are going to be autorouted BEFORE any of them is routed, as
 * `redrawWires` does and for the same reason: a wire may be routed as a branch off another wire of
 * its own net, and a route which is about to be thrown away is not one to follow. `sameNetRoutes`
 * passes over a wire with no segments, so what each wire can see is exactly the wires that are
 * where they now belong - the ones already re-routed, and the ones that never moved.
 * 
 * A wire the user has routed by hand keeps its segments: `partialAutoroute` holds the shape they
 * dragged it into by working from the segments already there, and there is nothing to recover
 * that from once they are gone. Those are re-routed before the autorouted ones, so that the rest
 * of their net can follow them.
 * 
 * Autorouted wires go shortest first, again as `redrawWires` does: a short wire has the least
 * freedom in where it can go, so it is the one that should already be there when a longer wire of
 * its net is looking for something to join.
 */
export function rerouteMovedWires(translate, compIdList, model) {
    const wires = filterWiresByCompMoved(model, compIdList);
    const bothEndsMoved = ofList(wires.Both, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const inputEndMoved = ofList(wires.Inputs, {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    const patternInput_1 = partition((wid_1) => isManuallyRouted(FSharpMap__get_Item(model.Wires, wid_1)), sortBy((wid) => {
        let portId_1, portId_5;
        const wire = FSharpMap__get_Item(model.Wires, wid);
        let patternInput;
        const model_1 = model.Symbol;
        patternInput = [getPortLocation(undefined, model_1, (portId_1 = (new DrawModelType_SymbolT_DirectedPortId(/* InputId */ 0, [wire.InputPort])), (portId_1.tag === 1) ? portId_1.fields[0] : portId_1.fields[0])), getPortLocation(undefined, model_1, (portId_5 = (new DrawModelType_SymbolT_DirectedPortId(/* OutputId */ 1, [wire.OutputPort])), (portId_5.tag === 1) ? portId_5.fields[0] : portId_5.fields[0]))];
        let vec;
        const left = patternInput[1];
        const right = patternInput[0];
        vec = (new XYPos(left.X - right.X, left.Y - right.Y));
        return Math.sqrt(Math.pow(vec.X, 2) + Math.pow(vec.Y, 2));
    }, filter((arg) => !FSharpSet__Contains(bothEndsMoved, arg), List_distinct(append(wires.Inputs, wires.Outputs), {
        Equals: equals,
        GetHashCode: (x_2) => (safeHash(x_2) | 0),
    })), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }));
    const autoRouted = patternInput_1[1];
    const route = (model_4, wid_2) => {
        let optic, value_2;
        return ((optic = DrawModelType_BusWireT_wireOf_(wid_2), (value_2 = updateWire(model_4, FSharpMap__get_Item(model_4.Wires, wid_2), FSharpSet__Contains(inputEndMoved, wid_2)), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic)(value_2))))(model_4);
    };
    return fold(route, fold(route, fold((model_7, wid_4) => {
        let l;
        return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, (l = DrawModelType_BusWireT_wireOf_(wid_4), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_segments_)(l)))(empty())(model_7);
    }, fold((model_5, wid_3) => {
        let optic_1, value_3;
        return ((optic_1 = DrawModelType_BusWireT_wireOf_(wid_3), (value_3 = translate(model_5, FSharpMap__get_Item(model_5.Wires, wid_3)), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, optic_1)(value_3))))(model_5);
    }, model, wires.Both), autoRouted), patternInput_1[0]), autoRouted);
}

/**
 * Re-routes the wires in the model based on a list of components that have been altered.
 * If the wire input and output ports are both in the list of moved components,
 * it does not re-route wire but instead translates it.
 * Keeps manual wires manual (up to a point).
 * Otherwise it will auto-route wires connected to components that have moved
 */
export function updateWires(model, compIdList, diff) {
    return rerouteMovedWires((_arg, wire) => moveWire(wire, diff), compIdList, model);
}

